module.exports = __webpack_public_path__ + "img/spotify.d92ba1f2.png";